var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from "../../Layout/Modal";
import { Translate } from "../../I18N";
import { removeProperty } from "../actions/templateActions";
import { hideModal } from "../../Modals/actions/modalActions";

export class RemovePropertyConfirm extends Component {
  confirm() {
    this.props.hideModal('RemovePropertyModal');
    this.props.removeProperty(this.props.propertyBeingDeleted);
  }

  render() {
    return /*#__PURE__*/(
      _jsx(Modal, { isOpen: this.props.isOpen || false, type: "danger", zIndex: 99 }, void 0, /*#__PURE__*/
      _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
      _jsx("h4", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Confirm deletion")
      ), /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Property delete warning" }, void 0, "Deleting a template property will delete this metadata information on all documents using this template."


      )
      ), /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Change will take effect after saving the template")
      )
      ), /*#__PURE__*/

      _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-default cancel-button",
        onClick: () => this.props.hideModal('RemovePropertyModal') }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Cancel")
      ), /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-danger confirm-button",
        onClick: () => this.confirm() }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Delete Property")
      )
      )
      ));

  }
}








const mapStateToProps = (state) => {
  const propertyBeingDeleted = state.modals.toJS().RemovePropertyModal;
  return {
    propertyBeingDeleted,
    isOpen: typeof propertyBeingDeleted === 'number'
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ hideModal, removeProperty }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(RemovePropertyConfirm);